import React, { useState, useEffect, useRef } from 'react';
import PostYourTenderLogo from '../../Assets/images/PostYourTenderLogo.png';
import apiClient from '../../Api/apiClient';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import Contact from '../../Components/Contact/Contact';
import TenderPublishDetails from './TenderPublishDetails';
import { RxCross1 } from 'react-icons/rx';
import { FaChevronRight } from 'react-icons/fa';
import PublishTenderAlert from '../../Components/Alert/PublishTenderAlert';
import TenderPublish from '../../Components/Landing/TenderPublish';
// Function to validate email
const validateEmail = email => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

const PublishTenderForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    designation: '',
    organization_name: '',
    tender_name: '',
    company_name: '',
    company_phone_number: '',
    tender_file: null,
    company_logo: null,
  });

  const [errors, setErrors] = useState({});
  const isAuthenticated = localStorage.getItem('bearer') !== null;
  const userType = localStorage.getItem('user_type');
  const [fileName, setFileName] = useState('');
  const [ImageFile, setImageFile] = useState('');

  const [isVisible, setIsVisible] = useState(false);
  const [countryCode, setCountryCode] = useState('88'); // Set default country code
  const detailsRef = useRef(null);
  const buttonRef = useRef(null);

  // Handle form field changes

  // Fetch profile data if authenticated
  const fetchProfileData = async () => {
    if (isAuthenticated) {
      try {
        let url = '/user/profile';
        if (userType === 'affiliator') {
          url = '/affiliator/profile';
        }
        const response = await apiClient.get(url);
        const { full_name, email, phone, designation, organization_name } =
          response.data.data;

        setFormData(prevData => ({
          ...prevData,
          name: prevData.name || full_name || '',
          email: prevData.email || email || '',
          phone: prevData.phone || phone || '',
          designation: prevData.designation || designation || '',
          organization_name:
            prevData.organization_name || organization_name || '',
        }));
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  const handleChange = e => {
    const { name, files } = e.target;

    // If files are selected
    if (files && files.length > 0) {
      const file = files[0];

      // Validate the file type for tender_file (only PDF allowed)
      // if (name === 'tender_file') {
      //   if (file.type !== 'application/pdf') {
      //     Swal.fire({
      //       title: 'Not Accept!',
      //       text: 'Please upload a valid PDF file.',
      //       customClass: {
      //         popup: 'w-72 h-auto p-3',
      //         title: '',
      //         content: 'text-xs',
      //         confirmButton:
      //           'bg-headerBtn text-white px-4 py-1  rounded-md',
      //       },
      //     });

      //     setErrors(prevErrors => ({
      //       ...prevErrors,
      //       tender_file: 'Please upload a valid PDF file.',
      //     }));
      //     e.target.value = null; // Clear the input to prevent uploading invalid file
      //     return;

      //   } else {
      //     // No errors if the file is a valid PDF
      //     setErrors(prevErrors => ({
      //       ...prevErrors,
      //       tender_file: '',
      //     }));
      //   }
      // }

      // Validate the file type for company_logo (only PNG or JPEG allowed)
      if (
        name === 'company_logo' &&
        !['image/png', 'image/jpeg', 'image/webp'].includes(file.type)
      ) {
        Swal.fire({
          title: 'Not Accept!',
          text: 'Please upload a valid Image.',
          customClass: {
            popup: 'w-72 h-auto p-3',
            title: '',
            content: 'text-xs',
            confirmButton: 'bg-headerBtn text-white px-4 py-1  rounded-md',
          },
        });

        setErrors(prevErrors => ({
          ...prevErrors,
          company_logo: 'Please upload a valid image (PNG or JPEG).',
        }));
        e.target.value = null; // Clear the input to prevent uploading invalid file
        return;
      } else {
        // Clear error if the file is valid
        setErrors(prevErrors => ({
          ...prevErrors,
          company_logo: '',
        }));
      }

      // Update formData with the file
      setFormData(prevData => ({
        ...prevData,
        [name]: file, // Store the raw File object
      }));

      // Set the file name for tender_file
      if (name === 'tender_file') {
        setFileName(file.name);
      }

      // Set the file name for company_logo
      if (name === 'company_logo') {
        setImageFile(file.name);
      }
    } else {
      // Handle non-file inputs (text, email, etc.)
      setFormData(prevData => ({
        ...prevData,
        [name]: e.target.value,
      }));
    }
  };

  // console.log("usertype in publish tender form:", userType);

  const handleSubmit = async e => {
    e.preventDefault();
    const apiEndpoint =
      userType === 'end_user'
        ? '/user/tender-end-user/publish-tender'
        : userType === 'user'
          ? '/user/tender-user/publish-tender'
          : userType === 'affiliator'
            ? '/affiliator/tender-request/publish-tender'
            : '/user/visitor/publish-tender';

    // Prepare FormData
    const submitdata = new FormData();
    submitdata.append('name', formData.name);
    submitdata.append('tender_name', formData.tender_name);
    submitdata.append('company_name', formData.company_name);
    if (formData.company_phone_number) {
      const fullPhoneNumber = countryCode + formData.company_phone_number; // countryCode is a state
      submitdata.append('company_phone_number', fullPhoneNumber);
    };

    // if (formData.phone) {
    //   const fullPhoneNumber = countryCode + formData.phone; // countryCode is a state
    //   submitdata.append('phone', fullPhoneNumber);
    // };
    submitdata.append('phone', formData.phone);
    submitdata.append('email', formData.email);
    submitdata.append('tender_file', formData.tender_file); // Append raw File
    if (formData.company_logo) {
      submitdata.append('company_logo', formData.company_logo);
    }
    submitdata.append('designation', formData.designation);
    submitdata.append('organization_name', formData.organization_name);

    console.log('before send form data:', formData);
    console.log(countryCode);

    // Submit the data
    try {
      const response = await apiClient.post(apiEndpoint, submitdata, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      console.log(response.data);

      const successMessage = response.data.message;
      Swal.fire({
        title: 'Success!',
        icon: 'success',
        text: successMessage,
        customClass: {
          popup: 'w-96 h-auto p-3',
          title: '',
          content: 'text-xs',
          confirmButton: 'bg-headerBtn text-white px-4 py-1  rounded-md',
        },
      });
      if (userType === null) {
        navigate('/login', {
          state: {
            user_name: response.data.username,
            pass_word: response.data.password,
          },
        });
      } else {
        navigate('/editMyTender');
      }
      // Clear form fields
      setFormData({
        tender_name: '',
        company_name: '',
        tender_file: '',
        company_logo: '',
      });
    } catch (error) {
      console.error('Error during submission:', error);
      const errorMessage = error.response?.data.message || 'An error occurred';
      Swal.fire({
        title: 'Failed!',
        text: errorMessage,
        icon: 'error',
        customClass: {
          popup: 'w-96 h-auto p-3',
          title: '',
          content: 'text-xs',
          confirmButton: 'bg-DefaultColor text-white px-4 py-1  rounded-md',
        },
      });
    }
  };

  const handleToggle = e => {
    e.preventDefault();
    setIsVisible(!isVisible);
    if (!isVisible) {
      setTimeout(() => {
        detailsRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  };

  const handleCloseToggle = () => {
    setIsVisible(!isVisible); // Show/hide toggle
    if (isVisible) {
      setTimeout(() => {
        buttonRef.current?.scrollIntoView({ behavior: 'smooth' });
      }, 100); // Scroll when becoming visible
    }
  };

  const handleRemovePDF = () => {
    setFileName('');
    document.getElementById('tender_file').value = ''; // Reset the file input
  };

  const handleRemovePic = () => {
    setImageFile(''); // Clear the image file name
    document.getElementById('company_logo').value = ''; // Reset the file input
  };

  return (
    <>
      <div
        ref={buttonRef}
        className="flex items-center justify-center md:mt-32 mt-20 2xl:mt-36 py-10 md:px-0 text-xs container mx-auto"
      >
        <div className="flex md:gap-6 2xl:gap-10 gap-0 flex-col md:flex-row bg-white overflow-hidden w-full">
          {/* Left Section */}
          <div className="w-full md:w-1/2">
            <PublishTenderAlert />
            <TenderPublish />
          </div>

          {/* Right Section (Form) */}
          <div className=" w-full md:w-1/2 ">
            <form onSubmit={handleSubmit}>
              <div className="space-y-6 border bg-gradient-to-r from-publishTenderForm2 via-white to-publishTenderFormBackground px-7 py-6 mb-2">
                <p className=" mb2 text-left text-sm">
                  Post private tenders, RFQs, and auction notices here to
                  encourage competitive pricing and quality. Before submitting
                  this form, please review the terms of publishing tenders.
                </p>
                <button
                  onClick={handleToggle}
                  className=" px-6 py-2 bg-blue-600 bg-opacity-25 text-DefaultColor hover:text-white font-semibold rounded-md hover:bg-blue-400 transition flex gap-2 items-center"
                >
                  See details
                  <FaChevronRight
                    className={`transition-transform duration-300 ${isVisible ? 'rotate-90' : 'rotate-0'
                      }`}
                  />
                </button>

                <div className="grid grid-cols-1  gap-4">
                  {/* Tender Name */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="tender_name"
                      className=" font-semibold text-gray-700 w-full md:w-1/3"
                    >
                      Tender Name*
                    </label>
                    <input
                      id="tender_name"
                      name="tender_name"
                      type="text"
                      value={formData.tender_name}
                      onChange={handleChange}
                      placeholder="Enter tender's name"
                      required
                      className={`w-full md:w-2/3 p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.tender_name ? 'border-red-500' : ''
                        }`}
                    />
                  </div>

                  {/* Company Name */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="company_name"
                      className=" font-semibold text-gray-700 w-full  md:w-1/3"
                    >
                      Company Name*
                    </label>
                    <input
                      id="company_name"
                      name="company_name"
                      type="text"
                      value={formData.company_name}
                      onChange={handleChange}
                      placeholder="Enter company name"
                      required
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.company_name ? 'border-red-500' : ''
                        }`}
                    />
                  </div>

                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="phone"
                      className="font-semibold text-gray-700 w-full md:w-1/3"
                    >
                      Company Number *
                    </label>
                    {/* <input
                      id="company_phone_number"
                      name="company_phone_number"
                      type="tel"
                      value={formData.company_phone_number}
                      onChange={handleChange}
                      placeholder="Enter your company phone number"
                      required
                      className={`w-full md:w-2/3 p-3 border-2 border-gray-400 rounded-md shadow-sm  ${
                        errors.phone ? 'border-red-500' : ''
                      }`}
                    /> */}

                    <div className="w-full md:w-2/3 flex space-x-1">
                      <select
                        className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24 "
                        value={countryCode}
                        onChange={e => setCountryCode(e.target.value)}
                      >
                        <option value="88">+88(Ban)</option>
                        <option value="1">+1(USA/Canada)</option>
                        <option value="44">+44(UK)</option>
                        <option value="91">+91(India)</option>
                        <option value="61">+61(Aust)</option>
                        <option value="33">+33(France)</option>
                        <option value="49">+49(Germany)</option>
                        <option value="39">+39(Italy)</option>
                        <option value="81">+81(Japan)</option>
                        <option value="7">+7(Russia)</option>
                        <option value="86">+86(China)</option>
                        <option value="34">+34(Spain)</option>
                        <option value="55">+55(Brazil)</option>
                        <option value="27">+27(SA)</option>
                        <option value="52">+52(Mexico)</option>
                        <option value="20">+20(Egypt)</option>
                        <option value="45">+45(Denmark)</option>
                        <option value="31">+31(Netherlands)</option>
                        <option value="90">+90(Turkey)</option>
                        <option value="63">+63(Philippines)</option>
                        <option value="66">+66(Thailand)</option>
                        <option value="32">+32(Belgium)</option>
                        <option value="56">+56(Chile)</option>
                        <option value="46">+46(Sweden)</option>
                        <option value="351">+351(Portugal)</option>
                        <option value="965">+965(Kuwait)</option>
                        <option value="971">+971(UAE)</option>
                        <option value="30">+30(Greece)</option>
                        <option value="972">+972(Israel)</option>
                        <option value="964">+964(Iraq)</option>
                        <option value="256">+256(Uganda)</option>
                      </select>
                      <input
                        id="company_phone_number"
                        name="company_phone_number"
                        type="tel"
                        value={formData.company_phone_number}
                        onChange={handleChange}
                        placeholder="Enter your company phone number"
                        className={`w-full  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.phone ? 'border-red-500' : ''
                          }`}
                        required
                      />
                    </div>


                  </div>

                  {/* Tender File */}
                  {/* <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label htmlFor="tender_file" className=" font-medium text-gray-700 w-full  md:w-1/3">
                      Tender's File (PDF only)*
                    </label>
                    <input
                      id="tender_file"
                      name="tender_file"
                      type="file"
                      onChange={handleChange}
                      required
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.tender_file ? 'border-red-500' : ''}`}
                    />
                  </div> */}

                  <div className="flex items-center flex-col md:flex-row lg:flex-row">
                    <label
                      htmlFor="tender_file"
                      className="font-semibold text-gray-700 w-full md:w-1/3"
                    >
                      Tender's File (PDF/Image)*
                    </label>
                    <div className="w-full md:w-2/3 flex items-center border-2 bg-white border-gray-400 rounded-md shadow-sm p-1">
                      <input
                        type="text"
                        value={fileName}
                        placeholder="Choose your tender file"
                        className="flex-1 w-full md:w-2/3 p-2 px-2"
                        readOnly
                        id="file_name_display"
                        onClick={() => document.getElementById("tender_file").click()}

                      />
                      {/* Choose File Button */}
                      <label
                        htmlFor="tender_file"
                        className="bg-publishTenderChoosePDF text-black px-4 py-2 rounded-md cursor-pointer hover:bg-publishTenderFormBackground ml-2"
                      >
                        Choose PDF/Image
                      </label>
                      {/* Remove Button (conditionally rendered) */}
                      {fileName && (
                        <button
                          type="button"
                          onClick={handleRemovePDF}
                          className="bg-red-500 text-white px-4 py-2 rounded-md cursor-pointer hover:bg-red-600 ml-2"
                        >
                          Remove
                        </button>
                      )}
                      {/* Hidden File Input */}
                      <input
                        id="tender_file"
                        name="tender_file"
                        type="file"
                        accept="application/pdf, image/png, image/jpeg, image/jpg"
                        onChange={handleChange}
                        required
                        className="hidden"
                      />
                    </div>
                  </div>

                  {/* Company Logo */}
                  {/* <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label htmlFor="company_logo" className=" font-medium text-gray-700 w-full  md:w-1/3">
                      Company Logo
                    </label>
                    <input
                      id="company_logo"
                      name="company_logo"
                      type="file"
                      onChange={handleChange}
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.company_logo ? 'border-red-500' : ''}`}
                    />
                  </div> */}

                  <div className="flex items-center flex-col md:flex-row lg:flex-row">
                    <label
                      htmlFor="company_logo"
                      className="font-semibold text-gray-700 w-full md:w-1/3"
                    >
                      Company Logo
                    </label>
                    <div className="w-full md:w-2/3 flex items-center border-2 bg-white border-gray-400 rounded-md shadow-sm p-1">
                      <input
                        value={ImageFile}
                        placeholder="Choose company logo"
                        className="flex-1 w-full md:w-2/3 p-2 px-2"
                        readOnly
                        id="company_name_display"
                        onClick={() => document.getElementById("company_logo").click()}

                      />
                      {/* Choose Image Button */}
                      <label
                        htmlFor="company_logo"
                        className="bg-publishTenderChoosePDF text-black px-4 py-2 rounded-md cursor-pointer hover:bg-publishTenderForm2 ml-2"
                      >
                        Choose image
                      </label>
                      {/* Remove Button (conditionally rendered) */}
                      {ImageFile && (
                        <button
                          type="button"
                          onClick={handleRemovePic}
                          className="bg-red-500 text-white px-4 py-2 rounded-md cursor-pointer hover:bg-red-600 ml-2"
                        >
                          Remove
                        </button>
                      )}
                      {/* Hidden File Input */}
                      <input
                        id="company_logo"
                        name="company_logo"
                        type="file"
                        accept="image/png, image/jpeg, image/jpg"
                        onChange={handleChange}
                        className="hidden"
                      />
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  {/* Contact Person Details */}
                  <label className="text-xm md:xl lg:xl font-medium text-gray-500 mt-4">
                    Contact person details
                  </label>
                  {/* Person Name */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="name"
                      className="font-semibold text-gray-700 w-full  md:w-1/3"
                    >
                      Name*
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      required
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.name ? 'border-red-500' : ''
                        }`}
                    />
                  </div>

                  {/* Phone Number */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="phone"
                      className="font-semibold text-gray-700 w-full  md:w-1/3"
                    >
                      Phone *
                    </label>
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your phone number"
                      required
                      className={`w-full md:w-2/3 p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.phone ? 'border-red-500' : ''
                        }`}
                    />
                  </div>


                  {/* <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="phone"
                      className="font-semibold text-gray-700 w-full  md:w-1/3"
                    >
                      Phone *
                    </label>

                    <div className="w-full md:w-2/3 flex space-x-1">
                      <select
                        className="border text-xs border-gray-300 rounded-md py-2 px-1 w-24 "
                        value={countryCode}
                        onChange={e => setCountryCode(e.target.value)}
                      >
                        <option value="88">+88(Ban)</option>
                        <option value="1">+1(USA/Canada)</option>
                        <option value="44">+44(UK)</option>
                        <option value="91">+91(India)</option>
                        <option value="61">+61(Aust)</option>
                        <option value="33">+33(France)</option>
                        <option value="49">+49(Germany)</option>
                        <option value="39">+39(Italy)</option>
                        <option value="81">+81(Japan)</option>
                        <option value="7">+7(Russia)</option>
                        <option value="86">+86(China)</option>
                        <option value="34">+34(Spain)</option>
                        <option value="55">+55(Brazil)</option>
                        <option value="27">+27(SA)</option>
                        <option value="52">+52(Mexico)</option>
                        <option value="20">+20(Egypt)</option>
                        <option value="45">+45(Denmark)</option>
                        <option value="31">+31(Netherlands)</option>
                        <option value="90">+90(Turkey)</option>
                        <option value="63">+63(Philippines)</option>
                        <option value="66">+66(Thailand)</option>
                        <option value="32">+32(Belgium)</option>
                        <option value="56">+56(Chile)</option>
                        <option value="46">+46(Sweden)</option>
                        <option value="351">+351(Portugal)</option>
                        <option value="965">+965(Kuwait)</option>
                        <option value="971">+971(UAE)</option>
                        <option value="30">+30(Greece)</option>
                        <option value="972">+972(Israel)</option>
                        <option value="964">+964(Iraq)</option>
                        <option value="256">+256(Uganda)</option>
                      </select>
                      <input
                        id="phone"
                        name="phone"
                        type="tel"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="Enter your phone number"
                        required
                        className={`w-full  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.phone ? 'border-red-500' : ''
                          }`}

                      />
                    </div>

                  </div> */}


                  {/* Email */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="email"
                      className="font-semibold text-gray-700 w-full  md:w-1/3"
                    >
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.email ? 'border-red-500' : ''
                        }`}
                    />
                  </div>

                  {/* Organization Name */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="organization_name"
                      className="font-semibold text-gray-700 w-full md:w-1/3"
                    >
                      Organization Name
                    </label>
                    <input
                      id="organization_name"
                      name="organization_name"
                      type="text"
                      value={formData.organization_name}
                      onChange={handleChange}
                      placeholder="Enter your institute"
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.organization_name ? 'border-red-500' : ''
                        }`}
                    />
                  </div>

                  {/* Designation */}
                  <div className="flex items-center flex-col md:flex-row lg:flex-row ">
                    <label
                      htmlFor="designation"
                      className="font-semibold text-gray-700 w-full  md:w-1/3"
                    >
                      Designation
                    </label>
                    <input
                      id="designation"
                      name="designation"
                      type="text"
                      value={formData.designation}
                      onChange={handleChange}
                      placeholder="Enter your designation"
                      className={`w-full md:w-2/3  p-3 border-2 border-gray-400 rounded-md shadow-sm  ${errors.designation ? 'border-red-500' : ''
                        }`}
                    />
                  </div>
                </div>

                {errors.submit && (
                  <p className="text-red-500 text-xs text-center">
                    {errors.submit}
                  </p>
                )}
                <div className="flex  justify-center mt-6">
                  <button
                    type="submit"
                    className="text-sm px-6 py-2 bg-publishTenderBtn text-white rounded-md hover:bg-yellow-600 transition"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {isVisible && (
        <div className="flex flex-col items-end" ref={detailsRef}>
          <button
            className="mx-5 p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition duration-300 shadow-md focus:outline-none focus:ring-2 focus:ring-red-400"
            onClick={handleCloseToggle}
          >
            <RxCross1 size={20} />
          </button>

          <TenderPublishDetails className="mt-0" />
        </div>
      )}

      <Contact />
    </>
  );
};

export default PublishTenderForm;
